import $ from 'jquery';
import { getInputValue } from '../utils/input';
const ELEMENT_SELECTOR = '.js__mirror-input-value-to-element';
export class MirrorInputValueToElement {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        $elements.each((index, element) => {
            let $element = $(element);
            if ($element.hasClass('ui dropdown')) {
                $element = $element.find('select');
            }
            const $target = $($element.data('target'));
            $target.on('change', event => {
                this.handleValueChange($(event.target), $element);
            });
            if ($element.data('set-value-on-load')) {
                this.handleValueChange($target, $element);
            }
        });
    }
    static handleValueChange($target, $element) {
        const value = getInputValue($target);
        const { minusDays } = $element.data();
        if (minusDays) {
            const date = new Date(String(value));
            date.setDate(date.getDate() - minusDays);
            $element.text(value ? date.toISOString().slice(0, 10) : '');
        }
        else {
            $element.text(String(value) || '');
        }
    }
}
